import { Routes, RouterModule } from '@angular/router';

export const Full_ROUTES: Routes = [
  {
    path: 'cart',
    loadChildren: () => import('../cart/cart.module').then(m => m.CartModule),
  },
  {
    path: 'my-account',
    loadChildren: () => import('../my-accounts/my-accounts.module').then(m => m.MyAccountsModule),
  },
  {
    path: '',
    loadChildren: () => import('../pages/pages.module').then(m => m.PagesModule),
  },
  { path: '**', redirectTo: '' }
];
